import { gql } from '@apollo/client';

export default gql`
  query getTickets($bookingReference: String!, $lastName: String!, $language: Language, $ticketNumbers: [String!]) {
    getTickets(
      bookingReference: $bookingReference
      lastName: $lastName
      language: $language
      ticketNumbers: $ticketNumbers
      combine: true
      skipTravelDocs: true
    ) {
      language
      bookingReference
      passengers {
        id
        firstName
        lastName
        tickets {
          departure {
            departureDate
            departureTime
            station {
              stationName
            }
          }
          arrival {
            station {
              stationName
            }
          }
          ticketNumber
          ticketUrls {
            googlePassUrl
            appleWalletUrl
            pdfUrl
          }
        }
      }
    }
  }
`;
